import { AccountBalance } from 'vopay';

/**
 * The status an account is in, as the portal reads it: Blocked overrides everything, an active
 * account is Active, otherwise the onboarding status the API reports. The status badge and
 * anything that gates on "is this account usable" must agree, so both read it from here.
 */
export default function derivePartnerAccountStatus(account: Pick<AccountBalance, 'AccountStatus' | 'IsActive'>) {
  if (account.AccountStatus === 'Blocked') return 'Blocked';

  return account.IsActive ? 'Active' : account.AccountStatus;
}
